import DOMPurify from 'dompurify';

const getTextFromHTML = (input: string) => {
    const span = document.createElement('span');

    span.innerHTML = DOMPurify.sanitize(input);

    return span.textContent || span.innerText;
};

export default getTextFromHTML;
